module.exports = __webpack_public_path__ + "static/swim-lessons-d3ff97c2c1759130a9134d86f7a72002.jpg";